<template>
  <div class="self-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "自观数据" }}</span>
      </div>
      <div class="title-right"></div>
    </div>
    <div class="head-box">
      <div class="func-cell" @click="showPicker = true">
        <span>{{ columnsText[selectIndex] }}</span
        ><i class="my-right" />
      </div>
    </div>
    <div class="body-box">
      <div class="list-head">
        <span>最新资料时次：{{ datetimeValue }}(UTC)</span>
      </div>
      <div class="list-body">
        <div
          v-for="(item, i) in list.list"
          :key="i"
          :class="{
            'sf-row': true,
            'cell-bg-color': i % 2 < 1
          }"
        >
          <div
            :class="{ 'sf-col-key': n === 'key', 'sf-col-val': n !== 'key' }"
            v-bind:key="n"
            v-for="(m, n) in item"
          >
            {{ m }}
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsText"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        item-height="40"
        visible-item-count="3"
      />
    </van-popup>
    <van-overlay :show="pageLoading" @click="show = false">
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "self",
  data() {
    return {
      pageLoading: false,
      title: "",
      value: "ZWYT",
      datetimeValue: "",
      showPicker: false,
      columnsText: [
        "ZWYT 于田机场",
        "ZWZS 昭苏机场",
        "ZWAT 阿勒泰机场",
        "ZWCM 且末机场",
        "ZWFY 富蕴机场",
        "ZWHM 哈密机场",
        "ZWKC 库车机场",
        "ZWKL 库尔勒机场",
        "ZWKM 克拉玛依机场",
        "ZWKN 喀纳斯机场",
        "ZWNL 那拉提机场",
        "ZWRQ 若羌机场",
        "ZWSC 莎车机场",
        "ZWSH 喀什机场",
        "ZWTC 塔城机场",
        "ZWTN 和田机场",
        "ZWYN 伊宁机场",
        "ZWTL 吐鲁番机场",
        "ZWBL 博乐机场",
        "ZWTS 图木舒克机场"
        "ZWAL 阿拉尔机场"
        "ZWTK 塔什库尔干机场"
        "ZWHJ 巴音布鲁克机场"
        "ZWQT 奇台江布拉克机场"
      ],
      selectIndex: 0,
      // 闲置
      columns: [
        "ZWYT",
        "ZWZS",
        "ZWAT",
        "ZWCM",
        "ZWFY",
        "ZWHM",
        "ZWKC",
        "ZWKL",
        "ZWKM",
        "ZWKN",
        "ZWNL",
        "ZWRQ",
        "ZWSC",
        "ZWSH",
        "ZWTC",
        "ZWTN",
        "ZWYN",
        "ZWTL",
        "ZWBL",
        "ZWTS"
        "ZWAL"
        "ZWTK"
        "ZWHJ"
        "ZWQT"
      ],
      list: [],
      alllist: [], //处理后的数据（页面加载数据集）
      loading: false,
      finished: false,
      interID: "",
      cnFields: [
        { key: "STATIONNAME", label: "跑道端号", index: 0 },
        { key: "MOR_AVE_1M", label: "MOR_1分钟平均", index: 0 },
        { key: "MOR_AVE_10M", label: "MOR_10分钟平均", index: 0 },
        { key: "RVR_AVE_1M", label: "RVR_1分钟平均", index: 0 },
        { key: "RVR_AVE_10M", label: "RVR_10分钟平均", index: 0 },
        { key: "WINDDIR_AVE_2M", label: "风向_2分钟平均", index: 0 },
        { key: "WINDSPEED_AVE_2M", label: "风速_2分钟平均", index: 0 },
        { key: "WINDDIR_AVE_10M", label: "风向_10分钟平均", index: 0 },
        { key: "WINDSPEED_AVE_10M", label: "风速_10分钟平均", index: 0 },
        { key: "QNH_CURRENT", label: "修正海压", index: 0 },
        { key: "QFE_CURRENT", label: "场面气压", index: 0 },
        { key: "AIRTEMP_CURRENT", label: "温度", index: 0 },
        { key: "RH_CURRENT", label: "相对湿度", index: 0 },
        { key: "DEWTEMP_CURRENT", label: "露点温度", index: 0 }
      ],
      cnShowFieldsIdxs: []
    };
  },
  destroyed() {
    if (this.interID !== "") {
      clearInterval(this.interID);
      console.log(`已清除[${this.interID}]定时器!`);
    }
  },
  methods: {
    onConfirm(value, index) {
      this.selectIndex = index;
      this.value = this.columns[index];
      this.showPicker = false;
      if (this.alllist.length <= 0) {
        return;
      }
      this.againRealData(this.value);
      //this.getData();
    },
    setInterFnc() {
      let that = this;
      try {
        if (!that.interID) {
          let _interID = setInterval(function() {
            console.log("定时器执行!");
            that.getData();
          }, 30000);
          that.interID = _interID;
          console.log(`已设置[${this.interID}]定时器!`);
        }
      } catch (e) {
        console.log("设置定时器失败，error:", e);
      }
    },
    getData() {
      const that = this;
      let param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: "3",
        funversion: "2",
        dataRate: "onehour",
        collectionCode: "airport_in" //this.value||
      };
      let _stringify =
        this.$qstring.stringify(param) +
        "&funname=project/northwestaviation/obdata/GetLatestDataByCollectionCodeAndQueryTime&queryTime=" +
        this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      that.pageLoading = true;
      that.$http
        .get("/Services?" + _stringify)
        .then(r => {
          that.pageLoading = false;
          console.log("自观源数据：", r);
          that.realData(r["data"]);
        })
        .catch(e => {
          that.pageLoading = false;
          that.alllist = [];
          console.log("获取自观数据异常:", e);
        });
    },
    againRealData(k) {
      const that = this;
      let _data = this.alllist[k];
      let result = [];
      // let _filtr = ["HAPPENTIME"]; //过滤字段
      let timeindex = _data[0].indexOf("HAPPENTIME");
      try {
        for (let i = 0, len = this.cnFields.length; i < len; i++) {
          result.push({
            key: that.cnFields[i].label,
            val_1: _data[1][that.cnFields[i].index],
            val_2: _data[2][that.cnFields[i].index]
          });
        }
        this.list = { time: _data[1][timeindex], list: result };
      } catch (e) {
        console.log("againRealData函数异常：", e);
      }
    },
    realData(o) {
      console.log("开始数据处理...");
      if (o["Rows"].length <= 0) {
        console.log("没有可处理数据！Rows:", o["Rows"]);
        this.alllist = [];
        return;
      }
      let result = {};
      let codeindex = o["FieldName"].indexOf("AIRPORTCODE");
      let datetimeindex = o["FieldName"].indexOf("HAPPENTIME");
      this.datetimeValue = o["Rows"][0][datetimeindex];
      this.cnFields.map(m => {
        m.index = o["FieldName"].indexOf(m.key);
      });
      try {
        for (let m = 0; m < o["Rows"].length; m++) {
          if (Object.keys(o["Rows"][m]).length <= 1) {
            continue;
          }
          /*for(let n=0;n<o['Rows'][m].length;n++){
            let _o = {}
          }*/
          if (o["Rows"][m][codeindex] in result) {
            result[o["Rows"][m][codeindex]].push(o["Rows"][m]);
          } else {
            result[o["Rows"][m][codeindex]] = [o["FieldName"]];
            result[o["Rows"][m][codeindex]].push(o["Rows"][m]);
          }
        }
        this.alllist = result;
        this.againRealData(this.value);
      } catch (e) {
        console.log("处理数据异常：", e);
      }
      console.log("处理前的数据：", o);
      console.log("处理后的数据：", this.alllist);
    },
    makeTestData() {
      let _data = {
        Name: "",
        FieldName: [
          "AIRPORTCODE",
          "STATIONCODE",
          "STATIONNAME",
          "STATIONTYPE",
          "LONGITUDE",
          "LATITUDE",
          "HAPPENTIME",
          "AIRTEMP_CURRENT",
          "RAIN_SUM_CURRENT",
          "PRESSURE_CURRENT",
          "VIS_CURRENT",
          "WINDDIR_CURRENT",
          "WINDSPEED_CURRENT",
          "RH_CURRENT",
          "CLOUD_BASE",
          "DEWTEMP_CURRENT",
          "QNH_CURRENT",
          "RVR_AVE_10M",
          "MOR_AVE_10M",
          "QFE_CURRENT",
          "WINDDIR_CURRENT_MIN",
          "WINDDIR_CURRENT_MAX",
          "WINDDIR_AVE_2M",
          "WINDSPEED_AVE_2M",
          "WINDDIR_2M_MIN",
          "WINDDIR_2M_MAX",
          "WINDDIR_AVE_10M",
          "WINDSPEED_AVE_10M",
          "WINDDIR_MAX_10M",
          "WINDSPEED_MAX_10M",
          "WINDDIR_10M_MIN",
          "WINDDIR_10M_MAX",
          "WEATHERDESC_CURRENT",
          "SURFACESTATUS_CURRENT",
          "WINDSPEED_AVE_MAX_10M",
          "RVR_AVE_1M",
          "RVR_AVE_2M",
          "RVR_CURRENT",
          "MOR_AVE_1M",
          "MOR_AVE_2M",
          "MOR_CURRENT"
        ],
        FieldType: [
          "String",
          "String",
          "String",
          "String",
          "Decimal",
          "Decimal",
          "DateTime",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "String",
          "String",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "Decimal",
          "String",
          "String",
          "String",
          "String",
          "String",
          "String",
          "String",
          "String",
          "String"
        ],
        Rows: [
          [
            "ZWBL",
            "10",
            "10",
            "1",
            82.02,
            44.9,
            "2020-05-19 17:01:00",
            null,
            0,
            null,
            10000,
            171,
            3.5,
            null,
            null,
            null,
            null,
            "P2000",
            "10000",
            null,
            149.0,
            217.0,
            185,
            4.8,
            97.0,
            227.0,
            189,
            4.7,
            205,
            6.2,
            97.0,
            227.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWBL",
            "28",
            "28",
            "1",
            82.02,
            44.9,
            "2020-05-19 17:01:00",
            null,
            0,
            null,
            10000,
            210,
            2.3,
            null,
            null,
            null,
            null,
            "P2000",
            "10000",
            null,
            114.0,
            210.0,
            201,
            2.5,
            108.0,
            216.0,
            170,
            2.5,
            216,
            3.7,
            108.0,
            216.0,
            "",
            "",
            "3",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWAT",
            "12",
            "12",
            "1",
            88.05,
            47.75,
            "2020-05-19 17:01:00",
            29.4,
            null,
            921,
            10000,
            271,
            4.8,
            17,
            null,
            2.1,
            1008.5,
            "P2000",
            "10000",
            921,
            270.0,
            293.0,
            272,
            5.6,
            264.0,
            317.0,
            279,
            5.3,
            317,
            8.1,
            217.0,
            317.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWAT",
            "30",
            "30",
            "1",
            88.05,
            47.75,
            "2020-05-19 17:01:00",
            29.3,
            null,
            921.5,
            10000,
            237,
            4,
            17,
            null,
            2,
            1008.7,
            "P2000",
            "10000",
            921.6,
            237.0,
            270.0,
            249,
            5.4,
            236.0,
            301.0,
            268,
            5.6,
            301,
            9.3,
            236.0,
            301.0,
            "",
            "",
            "6",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWYN",
            "24",
            "24",
            "1",
            81.2,
            43.57,
            "2020-05-19 17:01:00",
            17.4,
            null,
            937.2,
            10000,
            265,
            6,
            72,
            1020,
            12.4,
            1016.7,
            "P2000",
            "10000",
            937,
            260.0,
            269.0,
            263,
            5.4,
            249.0,
            292.0,
            266,
            5.3,
            292,
            7.2,
            243.0,
            292.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWYN",
            "06",
            "06",
            "1",
            81.2,
            43.57,
            "2020-05-19 17:01:00",
            18,
            0,
            939.1,
            10000,
            266,
            4.1,
            67,
            1380,
            11.9,
            1016.6,
            "P2000",
            "10000",
            939.1,
            248.0,
            266.0,
            256,
            5,
            237.0,
            280.0,
            255,
            5.1,
            280,
            7.3,
            232.0,
            280.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWFY",
            "fy_12",
            "12",
            "1",
            89.48,
            47.01,
            "2020-05-19 17:01:00",
            27.8,
            null,
            902,
            70000,
            327,
            11.7,
            21,
            null,
            3.8,
            1009.5,
            "P2000",
            "40000",
            901.9,
            323.0,
            336.0,
            331,
            11.4,
            316.0,
            348.0,
            330,
            11.3,
            348,
            14.2,
            298.0,
            356.0,
            "",
            "",
            "11",
            "P2000",
            "P2000",
            "P2000",
            "60000",
            "50000",
            "70000"
          ],
          [
            "ZWFY",
            "fy_30",
            "30",
            "1",
            89.48,
            47.01,
            "2020-05-19 17:01:00",
            27.9,
            0,
            902.3,
            40000,
            323,
            11.7,
            19,
            null,
            2.4,
            1009.6,
            "P2000",
            "40000",
            902.4,
            312.0,
            340.0,
            329,
            9.4,
            303.0,
            342.0,
            321,
            9.8,
            342,
            13.6,
            301.0,
            342.0,
            "",
            "",
            "10",
            "P2000",
            "P2000",
            "P2000",
            "40000",
            "40000",
            "40000"
          ],
          [
            "ZWTL",
            "09",
            "09",
            "1",
            89.07,
            43.02,
            "2020-05-19 17:01:00",
            36.8,
            0,
            967.9,
            10000,
            178,
            5.1,
            13,
            null,
            4.4,
            1000.8,
            "P2000",
            "10000",
            967.7,
            178.0,
            197.0,
            183,
            4.6,
            168.0,
            203.0,
            184,
            4.9,
            203,
            6.4,
            127.0,
            203.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "P2000",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWTL",
            "27",
            "27",
            "1",
            89.07,
            43.02,
            "2020-05-19 17:01:00",
            36.5,
            null,
            968.5,
            10000,
            183,
            5.4,
            13,
            null,
            4.1,
            1000.8,
            "P2000",
            "10000",
            968.5,
            145.0,
            214.0,
            165,
            3.6,
            145.0,
            241.0,
            199,
            2.9,
            241,
            5.8,
            145.0,
            241.0,
            "",
            "",
            "3",
            "P2000",
            "P2000",
            "P2000",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWKL",
            "04",
            "04",
            "1",
            86.08,
            41.415,
            "2020-05-19 17:01:00",
            32.1,
            null,
            900.6,
            10000,
            181,
            5.6,
            13,
            null,
            0.2,
            1004.6,
            "P2000",
            "10000",
            900.6,
            169.0,
            183.0,
            168,
            5.6,
            136.0,
            194.0,
            166,
            5.3,
            194,
            7.4,
            128.0,
            194.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWKL",
            "22",
            "22",
            "1",
            86.08,
            41.415,
            "2020-05-19 17:01:00",
            null,
            null,
            900.6,
            10000,
            131,
            3.8,
            null,
            null,
            null,
            1004.7,
            "P2000",
            "10000",
            899.2,
            131.0,
            174.0,
            151,
            4.1,
            131.0,
            193.0,
            156,
            4.4,
            193,
            7,
            64.0,
            193.0,
            "",
            "",
            "4",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWTN",
            "29",
            "29",
            "1",
            79.52,
            37.02,
            "2020-05-19 17:01:00",
            21.5,
            null,
            851.2,
            10000,
            251,
            1.9,
            39,
            5430,
            7.1,
            1010.6,
            "P2000",
            "10000",
            851.2,
            223.0,
            251.0,
            239,
            2,
            188.0,
            289.0,
            253,
            1.9,
            312,
            3.2,
            188.0,
            312.0,
            "",
            "",
            "2",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWTN",
            "11",
            "11",
            "1",
            79.52,
            37.02,
            "2020-05-19 17:01:00",
            22,
            null,
            852.6,
            10000,
            268,
            0.4,
            38,
            6240,
            7.2,
            1010.5,
            "P2000",
            "10000",
            853,
            27.0,
            303.0,
            341,
            0.7,
            268.0,
            143.0,
            1,
            1,
            143,
            2,
            268.0,
            143.0,
            "",
            "",
            "1",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWRQ",
            "rq_04",
            "04",
            "1",
            88.01,
            38.97,
            "2020-05-19 17:01:00",
            29.6,
            null,
            902.3,
            3200,
            249,
            7.1,
            19,
            780,
            3.5,
            1004.2,
            "P2000",
            "3200",
            902.1,
            247.0,
            250.0,
            250,
            7.1,
            237.0,
            256.0,
            248,
            6.6,
            277,
            9,
            234.0,
            277.0,
            "",
            "",
            "7",
            "P2000",
            "P2000",
            "",
            "3200",
            "3200",
            "3200"
          ],
          [
            "ZWRQ",
            "rq_22",
            "22",
            "1",
            88.01,
            38.97,
            "2020-05-19 17:01:00",
            29.5,
            null,
            903.2,
            3400,
            245,
            5.7,
            19,
            870,
            3.4,
            1004.2,
            "P2000",
            "3400",
            903.3,
            233.0,
            261.0,
            247,
            5.2,
            227.0,
            261.0,
            244,
            5,
            280,
            7.1,
            210.0,
            280.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "3400",
            "3400",
            "3400"
          ],
          [
            "ZWSC",
            "33",
            "33",
            "1",
            77.06,
            38.25,
            "2020-05-19 17:01:00",
            28.4,
            null,
            861.4,
            10000,
            320,
            5.1,
            13,
            null,
            -2.7,
            1007.5,
            "P2000",
            "10000",
            861.3,
            302.0,
            345.0,
            298,
            4.3,
            282.0,
            347.0,
            317,
            4.8,
            4,
            6.5,
            282.0,
            4.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWSC",
            "15",
            "15",
            "1",
            77.06,
            38.25,
            "2020-05-19 17:01:00",
            27.8,
            null,
            862,
            10000,
            83,
            1.3,
            13,
            null,
            -3.2,
            1007.2,
            "P2000",
            "10000",
            862.1,
            32.0,
            104.0,
            92,
            2.2,
            59.0,
            118.0,
            350,
            2.6,
            118,
            4.4,
            282.0,
            118.0,
            "",
            "",
            "3",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWHM",
            "hm_11",
            "11",
            "1",
            93.44,
            42.78,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWHM",
            "hm_29",
            "29",
            "1",
            93.44,
            42.78,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWCM",
            "cm_04",
            "04",
            "1",
            85.319,
            38.089,
            "2020-05-19 17:01:00",
            25.6,
            0,
            870.3,
            4200,
            163,
            4.2,
            25,
            null,
            4.4,
            1007.9,
            "P2000",
            "4100",
            870.4,
            163.0,
            225.0,
            179,
            3.3,
            157.0,
            256.0,
            222,
            2.9,
            263,
            4.2,
            157.0,
            283.0,
            "",
            "",
            "3",
            "P2000",
            "P2000",
            "P2000",
            "4100",
            "4100",
            "4200"
          ],
          [
            "ZWCM",
            "cm_22",
            "22",
            "1",
            85.319,
            38.089,
            "2020-05-19 17:01:00",
            null,
            null,
            null,
            4600,
            null,
            null,
            null,
            null,
            null,
            1007.9,
            "P2000",
            "4700",
            871.1,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "",
            "",
            "",
            "P2000",
            "P2000",
            "P2000",
            "4600",
            "4600",
            "4600"
          ],
          [
            "ZWKM",
            "31",
            "31",
            "1",
            84.571,
            45.276,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWKM",
            "13",
            "13",
            "1",
            84.571,
            45.276,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWNL",
            "08",
            "08",
            "1",
            83.27,
            43.41,
            "2020-05-19 17:01:00",
            null,
            null,
            null,
            10000,
            242,
            5.9,
            null,
            null,
            null,
            1016.6,
            "P2000",
            "10000",
            910,
            238.0,
            251.0,
            242,
            6.2,
            224.0,
            259.0,
            243,
            6.5,
            259,
            9.7,
            224.0,
            260.0,
            "",
            "",
            "7",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWNL",
            "26",
            "26",
            "1",
            83.27,
            43.41,
            "2020-05-19 17:01:00",
            17.5,
            null,
            null,
            10000,
            253,
            7.3,
            66,
            1140,
            11.2,
            1016.6,
            "P2000",
            "10000",
            908.7,
            248.0,
            266.0,
            254,
            7.7,
            240.0,
            266.0,
            251,
            7.6,
            266,
            10.3,
            232.0,
            267.0,
            "",
            "",
            "8",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWTC",
            "tc_12",
            "12",
            "1",
            83.207,
            46.402,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWTC",
            "tc_30",
            "30",
            "1",
            83.207,
            46.402,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ],
          [
            "ZWKC",
            "kc_08",
            "08",
            "1",
            82.591,
            41.43,
            "2020-05-19 17:01:00",
            32,
            0,
            888.8,
            3400,
            150,
            2.2,
            14,
            960,
            1.2,
            1005.4,
            "P2000",
            "3500",
            888.9,
            150.0,
            178.0,
            155,
            3.7,
            138.0,
            187.0,
            165,
            3.6,
            187,
            5.2,
            138.0,
            199.0,
            "",
            "",
            "4",
            "P2000",
            "P2000",
            "",
            "3400",
            "3400",
            "3400"
          ],
          [
            "ZWKC",
            "kc_26",
            "26",
            "1",
            82.591,
            41.43,
            "2020-05-19 17:01:00",
            31.8,
            0,
            888.1,
            3200,
            200,
            2.3,
            15,
            840,
            2,
            1005.3,
            "P2000",
            "3500",
            888,
            160.0,
            200.0,
            186,
            2.6,
            133.0,
            219.0,
            167,
            2.8,
            219,
            4.2,
            110.0,
            219.0,
            "",
            "",
            "3",
            "P2000",
            "P2000",
            "",
            "3200",
            "3200",
            "3200"
          ],
          [
            "ZWSH",
            "sh_08",
            "08",
            "1",
            76.012,
            39.325,
            "2020-05-19 17:01:00",
            null,
            null,
            null,
            10000,
            74,
            3.6,
            null,
            null,
            null,
            null,
            "P2000",
            "10000",
            null,
            60.0,
            106.0,
            69,
            3.9,
            41.0,
            117.0,
            86,
            5,
            117,
            8.1,
            41.0,
            128.0,
            "",
            "",
            "5",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ],
          [
            "ZWSH",
            "sh_26",
            "26",
            "1",
            76.012,
            39.325,
            "2020-05-19 17:01:00",
            27,
            null,
            854.6,
            10000,
            276,
            2.8,
            14,
            null,
            -2.8,
            1008.2,
            "P2000",
            "10000",
            853.9,
            166.0,
            276.0,
            228,
            1.6,
            141.0,
            304.0,
            178,
            2.1,
            304,
            5,
            77.0,
            304.0,
            "",
            "",
            "2",
            "P2000",
            "P2000",
            "",
            "10000",
            "10000",
            "10000"
          ]
        ]
      };
      this.realData(_data);
    }
  },
  created() {
    let that = this;
    //that.makeTestData();
    that.getData();
    that.setInterFnc();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.self-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .func-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: px2rem(44);
      width: 100%;
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.24),
        inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: px2rem(12);
      span {
        font-size: px2rem(16);
        color: #a0a2a4;
        margin-left: px2rem(17);
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-right: px2rem(19);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
    /*border: 1px solid greenyellow;*/
  }
  .body-box {
    height: 82%;
    width: 95%;
    //margin-top: px2rem(12);
    .list-head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 8%;
      span {
        font-size: 14px;
        color: #a9abad;
      }
    }
    .list-body {
      height: 92%;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      .sf-row {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 10%;
        width: 100%;
        background-color: rgba(43, 62, 74, 0);
        flex-shrink: 0;
        font-size: px2rem(14);
      }
      .cell-bg-color {
        background-image: linear-gradient(
          180deg,
          rgb(33, 36, 40),
          rgb(33, 36, 40)
        );
      }
      .sf-col-key {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 100%;
        color: #ffffff;
      }
      .sf-col-val {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 20%;
        height: 100%;
        color: #d8d8d8;
      }
    }
  }
}
</style>
